{
  "min": 114,
  "max": 800,
  "R": [0, 255, 255, 255],
  "G": [0, 0, 129, 255],
  "B": [0, 0, 0, 255],
  "A": [0, 64, 88, 228],
  "I": [0, 80, 160, 255]
}
